/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import { API_ENDPOINTS } from "../../Constants";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getDriverList: (params) => {
    return axios.get(API_ENDPOINTS.GET_DRIVER_USER, {
      headers: { isAuthRequired: true, "Content-Type": "application/json","x-tenant-slug":"default" },
      params,
    });
  },
  getDriverDetailsById: (id, params = { userType: "DRIVER" }) => {
    let url = API_ENDPOINTS.DRIVER_ENDPOINT + "/" + id;
    return axios.get(url, {
      headers: { isAuthRequired: true, "Content-Type": "application/json","x-tenant-slug":"default" },
      params,
    });
  },
  getDocumentsTypes: (userType = "DRIVER") => {
    const normalizedUserType = (userType || "").toString().trim().toUpperCase();
    let url =
      normalizedUserType === "PROGRAM"
        ? API_ENDPOINTS.DRIVER_DOCUMENTS_TYPE_V2
        : API_ENDPOINTS.DRIVER_DOCUMENTS_TYPE;
    return axios.get(url, {
      headers: { isAuthRequired: true, "Content-Type": "application/json","x-tenant-slug":"default" },
      params: { type_user: normalizedUserType || "DRIVER" },
    });
  },
  getdriverEarningList: (params) => {
    return axios.get(API_ENDPOINTS.GET_ALL_DRIVER_EARNINGS_LIST, {
      headers: { isAuthRequired: true, "Content-Type": "application/json","x-tenant-slug":"default" },
      params,
    });
  },
  getdriverEarning: (params) => {
    return axios.get(API_ENDPOINTS.GET_A_DRIVER_EARNINGS_LIST, {
      headers: { isAuthRequired: true, "Content-Type": "application/json","x-tenant-slug":"default" },
      params,
    });
  },
  getdriverRewardsList: (params) => {
  return axios.get(API_ENDPOINTS.GET_ALL_DRIVER_REWARDS_LIST, {
    headers: { isAuthRequired: true, "Content-Type": "application/json","x-tenant-slug":"default" },
    params,
  });
  },
  getdriverRewardlogs: (params) => {
    return axios.get(API_ENDPOINTS.GET_A_DRIVER_REWARDS_LIST, {
      headers: { isAuthRequired: true, "Content-Type": "application/json","x-tenant-slug":"default" },
      params,
    });
  },
   getdriverscashoutrecords: (params) => {
    return axios.get(API_ENDPOINTS.GET_A_DRIVERS_CASHOUTRECORDS, {
      headers: { isAuthRequired: true, "Content-Type": "application/json","x-tenant-slug":"default" },
      params,
    });
  },
updatedrivercashoutstatus: (id, data) => {
  let url = API_ENDPOINTS.UPDATE_A_DRIVERS_CASHOUTRECORDS + "/" + id;
  return axios.put(url, data, {
    headers: {
      isAuthRequired: true,
      "Content-Type": "application/json","x-tenant-slug":"default"
    },
  });
},

   getdriverscashoutsheets: (params) => {
    return axios.get(API_ENDPOINTS.GET_A_DRIVERS_CASHOUTSHEETS, {
      headers: { isAuthRequired: true, "Content-Type": "application/json","x-tenant-slug":"default" },
      params,
    });
  },
updatedrivercashoutsheets: (id, data) => {
  let url = API_ENDPOINTS.UPDATE_A_DRIVERS_CASHOUTSHEETS + "/" + id;
  return axios.put(url, data, {
    headers: {
      isAuthRequired: true,
      "Content-Type": "application/json","x-tenant-slug":"default"
    },
  });
},

  addDriver: (data) => {
    return axios.post(API_ENDPOINTS.ADD_DRIVER, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "multipart/form-data",
        "x-tenant-slug": "default",
      },
    });
  },
  updateDriver: (id, data) => {
    let url = API_ENDPOINTS.UPDATE_DRIVER + "/" + id;
    return axios.put(url, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "multipart/form-data",
        "x-tenant-slug": "default",
      },
    });
  },
      getDriverbankDetailsById: (id) => {
    let url = API_ENDPOINTS.GET_DRIVER_BANK_DETAILS_BY_ID + "/" + id;
    return axios.get(url, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
        "x-tenant-slug": "default",
      },
    });
  },
    updateDriverbankdetails: (id, data) => {
    let url = API_ENDPOINTS.UPDATE_DRIVER_BANK_DETAILS_BY_ID + "/" + id;
    return axios.post(url, data, {
     headers: {
       isAuthRequired: true,
       "Content-Type": "application/json",
       "x-tenant-slug": "default",
     },
    });
  },
  updateDriverRide: (data) => {
    return axios.put(API_ENDPOINTS.UPDATE_DRIVER_RIDE, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
        "x-tenant-slug": "default",
      },
    });
  },
  createDriverRide: (data) => {
    return axios.post(API_ENDPOINTS.CREATE_DRIVER_RIDE, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
        "x-tenant-slug": "default",
      },
    });
  },
  getDriverServiceDetails: (id) => {
    let url = `${API_ENDPOINTS.GET_DRIVER_SERVICE_DETAILS}` + "/" + id;
    return axios.get(url, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json","x-tenant-slug":"default"
      },
    });
  },
  getDriverDocumentsByDriverId: (id, params = { userType: "DRIVER" }) => {
    let url = `${API_ENDPOINTS.GET_DRIVER_DOCUMENTS_BY_DRIVER_ID}` + "/" + id;
    return axios.get(url, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json","x-tenant-slug":"default"
      },
      params,
    });
  },
  updateDriverDocument: (data) => {
    let url = `${API_ENDPOINTS.UPDATE_DRIVER_DOCUMENT_END_POINT}`;
    return axios.put(url, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "multipart/form-data","x-tenant-slug":"default"
      },
    });
  },
  deleteDriverDocument: (data) => {
    let url = `${API_ENDPOINTS.DELETE_DRIVER_DOCUMENT_END_POINT}`;
    return axios.request({
      method: "delete",
      url: url,
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json","x-tenant-slug":"default" // Use JSON for the body
      },
      data: data, // Pass the `document_id` in the request body
    });
  },
  createDriverDocuments: (data) => {
    let url = `${API_ENDPOINTS.DRIVER_DOCUMENT_END_POINT}`;
    return axios.post(url, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json","x-tenant-slug":"default"
      },
    });
  },
  updateDriverDocumentStatus: (driverId, documentId, data) => {
    let url =
      `${API_ENDPOINTS.DRIVER_DOCUMENT_UPDATE}` +
      "/" +
      driverId +
      "/" +
      documentId;
    return axios.put(url, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json","x-tenant-slug":"default"
      },
    });
  },
  getDriverCompleteDetailsByDId: (driverId, params = { userType: "DRIVER" }) => {
    let url = `${API_ENDPOINTS.DRIVER_COMPLETE_DETAILS}` + "/" + driverId;
    return axios.get(url, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json","x-tenant-slug":"default"
      },
      params,
    });
  },
  updateDriverServiceStatus: (driverId, data) => {
    let url = `${API_ENDPOINTS.UPDATE_DRIVER_SERVICE_STATUS}` + "/" + driverId;
    return axios.put(url, { userType: "DRIVER", ...(data || {}) }, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json","x-tenant-slug":"default"
      },
    });
  },
  updateDriverProgramStatus: (driverId, data) => {
    let url = `${API_ENDPOINTS.UPDATE_DRIVER_SERVICE_STATUS}` + "/" + driverId;
    return axios.put(url, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json","x-tenant-slug":"default"
      },
    });
  },
};
